import React, { useState } from "react";
import { Avatar, Button, Card, Row, Col, Upload } from "antd";

const { Meta } = Card;

export const FileCard = ({
  file,
  onFileRemove,
  onDownloadFile,
  onPreview,
  onFileSelection,
  uploadInfo,
}) => {
  const { documentType, fileName, size, type, typeDescription } = file;
  const [image, setImage] = useState(
    ["image/jpeg", "image/png", "image/jpg"].includes(type)
      ? "image.png"
      : "pdf.png"
  );
  const fSize = Math.floor(size / 1024);
  //Get the file type

  return (
    <Card
      key={fileName}
      hoverable
      className="mobile-docs-upload"
      style={{
        flex: 1,
        marginBottom: 10,
        marginTop: 4,
      }}
      // actions={[<Button onClick={onFileRemove(file)} danger>Preview</Button>, <Button onClick={onFileRemove(file)} danger>Download</Button>, <Button onClick={onFileRemove(file)} danger>Remove</Button>]}
      //  actions={[<Button onClick={() => onPreview(file)} danger>Preview</Button>]}
    >
      <Meta
        avatar={<Avatar src={require("../../assets/" + image)} />}
        title={fileName}
        description={`${typeDescription} ${fSize}KB`}
      />

      {/* <Button 
          style={{textAlign:"center", marginRight:"5px"}}
          type="primary"
          shape="round"
          onClick={() => onPreview(file)}>Preview</Button> */}

      <Button
        className="yel-button"
        style={{ textAlign: "center", marginRight: "5px" }}
        shape="round"
        type="primary"
        onClick={() => onDownloadFile(file)}
      >
        Download
      </Button>
      {file.id > 0 ? (
        <Upload
          key={1}
          defaultFileList={[]}
          {...uploadInfo}
          maxCount={1}
          multiple={false}
        >
          <Button
            className="red-button"
            shape="round"
            type="default"
            onClick={() => onFileSelection(file)}
          >
            Replace
          </Button>
        </Upload>
      ) : (
        <Button
          className="red-button"
          shape="round"
          type="primary"
          onClick={() => onFileRemove(file)}
        >
          Delete
        </Button>
      )}
    </Card>
  );
};

// export default FileCard;
